









































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import WebApiSettingProfileDialog from '@/components/atoms/WebApiSettingProfileDialog.vue';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { validateClientId } from '@/utils/conversionApiUtils';

@Component({
  components: { WebApiSettingProfileDialog },
})
export default class WebApiSettingProfile extends Vue {
  @Prop()
  private clientId!: string;
  @Prop()
  private clientSecret!: string;
  @Prop()
  private clientInfoExists!: boolean;

  private currentClientId: string = this.clientId;
  private currentClientSecret: string = this.clientSecret;
  private showCurrentClientSecret: boolean = false;

  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');
  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || this.ruleInputRequired,
    validateClientId,
  };

  @Watch('clientId')
  onClientIdChange(newVal: string) {
    this.currentClientId = newVal;
  }

  @Watch('clientSecret')
  onClientSecretChange(newVal: string) {
    this.currentClientSecret = newVal;
  }

  @Emit('create-conversion-api-client-info')
  private createConversionApiClientInfo() {
    return {
      clientId: this.currentClientId,
      clientSecret: this.currentClientSecret,
    };
  }

  @Emit('delete-conversion-api-client-info')
  private deleteConversionApiClientInfo() {}
}
